import {useEffect, useState} from 'react';
import { oneOf, node, bool, } from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const positionStyles = ({ direction }) =>
  ({
    right: `
      height: 100%;
      width: 100%;
      max-width: 270px;
      top: 0;
      right: 0;
      transform: translate3d(100%,0,0);
    `,
    bottom: `
      width: 100%;
      bottom: 0;
      transform: translate3d(0,100%,0);
    `,
}[direction]);

const Wrapper = styled.div`
  background-color: ${({theme}) => theme.colors.white};
  width: auto;
  height: auto;
  position: absolute;
  z-index: 102;
  visibility: hidden;
  transition: none;
  overflow: auto;

  ${(props) => positionStyles(props)};

  &.visible {
    visibility: visible;
    transition: transform .5s ease;
    transform: translate3d(0,0,0);
    box-shadow: 0 0 20px rgb(34 36 38 / 15%);
  }

  &.animating {
    ${(props) => positionStyles(props)};
    visibility: visible;
  }
`;

export function Sidebar({
  children,
  visible,
  direction,
}) {
  const [isVisible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);

  const componentClass = classNames({
    'visible': isVisible,
    'animating': animating,
  });

  // handle close animation
  useEffect(async () => {
    if(!visible && isVisible) {
      setAnimating(true);

      await new Promise(r => setTimeout(r, 500))
      setAnimating(false);
      setVisible(visible);

    } else {
      setVisible(visible);
    }
  }, [visible]);

  return (
    <Wrapper className={componentClass} direction={direction}>
      {children}
    </Wrapper>
  );
}

Sidebar.propTypes = {
  children: node.isRequired,
  visible: bool.isRequired,
  direction: oneOf(['right', 'bottom']),
};

Sidebar.defaultProps = {
  direction: 'right',
}

export const SidebarWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;